import React from 'react';
import { useSelector } from 'react-redux';
import { Direction, } from '@debbie/common/dist/interactions/index.js';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
import DefaultSummary from './DefaultSummary.js';
const PhoneSummary = (props) => {
    const phoneDetails = props.interaction.details;
    const phone = phoneDetails.phone;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(DefaultSummary, { ...props },
        React.createElement("div", null,
            phone && phone.locale ? `+${phone.locale} ` : '',
            phone && phone.number ? phone.number : ''),
        React.createElement("p", null, phoneDetails.tags &&
            !!phoneDetails.tags.length &&
            phoneDetails.tags.map(({ tag }, i) => (React.createElement(Badge, { key: tag + i, theme: THEME.COLOR_ACCENT, style: { marginRight: '5px' } }, (props.interaction.direction === Direction.INCOMING
                ? // @ts-ignore
                    lang.incomingPhoneCallTags[tag]
                : // @ts-ignore
                    lang.outgoingPhoneCallTags[tag]) || tag))))));
};
export default PhoneSummary;
//# sourceMappingURL=PhoneSummary.js.map